
















































import { Component, Vue } from "vue-property-decorator";
import { deleteChannelGroup, checkDelete } from "@/services/channels/channelGroupService";

@Component
export default class ChannelGroupDeleteModal extends Vue {
    channelGroupToBeDeleted: string = "";
    channelGroupName: string = ""
    isSaved: boolean = false;

    handleEnter(e: KeyboardEvent) {
        if (e.key === "Enter") {
            if (this.channelGroupToBeDeleted !== "") this.confirm();
            else this.close();
        }
    }

    removeEvent() {
        window.removeEventListener("keydown", this.handleEnter);
        this.isSaved = false;
        this.channelGroupToBeDeleted = "";
        this.channelGroupName = "";
    }

    open(channelGroupId: string, name: string) {
        checkDelete(channelGroupId).then(response => {
            if (response) {
                this.channelGroupToBeDeleted = channelGroupId;
                this.channelGroupName = name;
                this.$bvModal.show("modal-deleteChannelGroup");
            } else {
                this.$bvModal.show("modal-deleteChannelGroupNotAllowed");
            }

            window.addEventListener("keydown", this.handleEnter);
        });
    }

    close() {
        this.$bvModal.hide("modal-deleteChannelGroupNotAllowed");
    }

    decline() {
        this.$bvModal.hide("modal-deleteChannelGroup");
        this.channelGroupToBeDeleted = "";
        this.channelGroupName = "";
    }

    confirm() {
        if (this.isSaved) return;
        this.isSaved = true;
        deleteChannelGroup(this.channelGroupToBeDeleted).then(() => {
            this.$emit("reload");
            this.channelGroupToBeDeleted = "";
            this.channelGroupName = "";
            this.$bvModal.hide("modal-deleteChannelGroup");
        });
    }
}
